import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import ApiRequest from "../helpers/api_server";
import DropDownAlert from "./DropDownAlert";
import { STATUS_REASONS } from "../constants/status";

function ModalValidationCheck({
  typeReason = "ktp",
  setReason,
  formReason,
  resetModal,
  titleDoc,
  description,
}) {
  async function handleReasonDocument() {
    try {
      const data = await ApiRequest.post(`/customer/validation`, formReason);
      DropDownAlert.show("success", `Alasan Dokumen berhasil diubah`);
      setReason(formReason?.validation_status_id);
      resetModal();
    } catch (error) {
      DropDownAlert.show("danger", `[ubah alasan]:  ${error}`);
      resetModal();
    }
  }

  async function handleValidateCheck() {
    try {
      const data = await ApiRequest.post(
        `/customer/document/approve`,
        formReason
      );
      DropDownAlert.show("success", `Berhasil memvalidasi`);
      setReason(STATUS_REASONS.APPROVE);
      resetModal();
    } catch (error) {
      DropDownAlert.show("danger", `[validasi gagal]:  ${error}`);
      resetModal();
    }
  }

  const handleSubmit = () => {
    if (formReason?.is_valid === true) {
      handleValidateCheck();
      setReason(STATUS_REASONS.APPROVE);
    }

    if (formReason?.is_valid === undefined) {
      setReason(formReason?.validation_status_id);
      handleReasonDocument();
    }
    resetModal();
  };

  return (
    <Modal isOpen={true} size={"xl"} centered>
      <ModalHeader>Validasi Dokumen</ModalHeader>
      <ModalBody>
        <p className="text-xl" style={{ fontSize: 18 }}>
          Apakah ingin merubah validasi{" "}
          <span className="" style={{ fontWeight: "bold" }}>
            {titleDoc}
          </span>{" "}
          dengan catatan : <br />{" "}
          <span className="text-primary"> {description} </span> ?
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" className="ml-1" onClick={handleSubmit}>
          Ubah
        </Button>
        <Button color="danger" className="ml-1" onClick={resetModal}>
          Batal
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalValidationCheck;
